import { jsxs as $, jsx as s } from "react/jsx-runtime";
import h from "clsx";
import { forwardRef as A } from "react";
const N = (e) => h(e), a = "dds-textarea-v0152", M = A(
  ({
    ariaDescribedby: e,
    ariaLabel: l,
    ariaLabelledby: i,
    autocorrect: c = "off",
    autocomplete: d,
    autocapitalize: f = "none",
    className: t = "",
    defaultValue: n,
    disabled: m = !1,
    id: p,
    inputProps: x = {},
    invalid: o = !1,
    name: u,
    placeholder: b,
    readOnly: r = !1,
    ...v
  }, _) => {
    const C = {
      [a]: !0,
      [t]: t.length > 0,
      [`${a}--readonly`]: r,
      [`${a}--invalid`]: o
    };
    return /* @__PURE__ */ $("div", { className: N(C), ...v, children: [
      /* @__PURE__ */ s(
        "textarea",
        {
          className: `${a}__textarea`,
          "aria-describedby": e,
          "aria-invalid": o ? "true" : "false",
          "aria-label": l,
          "aria-labelledby": i,
          autoCapitalize: f,
          autoCorrect: c,
          autoComplete: d,
          defaultValue: n,
          disabled: m,
          id: p,
          name: u,
          placeholder: r ? void 0 : b,
          readOnly: r,
          ref: _,
          ...x
        }
      ),
      /* @__PURE__ */ s("div", { className: `${a}__container` })
    ] });
  }
);
export {
  M as Textarea
};
//# sourceMappingURL=index.js.map
